/**
 * 基础配置
 */
import form from '@/config/form.js'
import router from '@/config/router.js'
import settings from '@/config/settings.js'
import advertisement from '@/config/advertisement.js'
export default {
  // 游客token-CAC 正式
  'visitorToken': 'PBB+hfqyCn5u/Asp+KqEaro7AhH4z/+bW0+9qxZHTV3GqTTtK0xlBOZ/bJUKrMMzpQGrxvbaa1O+XC9IM1Esf+sq+GwKEVbFVC5oHf4ckhDvF0COJwODWI/otfPxmvDr8/lzo80KxYaPNqn7kEkK/5d3CRmNDUlQBGo9iBXFyJm9IcXhTs3UJ3PSx/3pyao67h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=',
  // 展会Id-CAC 正式
  'exhibitionId': 'b33d8960b7a245cb97146670283ac360',
  // appId-CAC  正式
  'appId': '7e46f33c139246069a3c17c9f4847a25',

  // SDKAppID  正式
  'SDKAppID': 1400363234,
  // token 名称
  'token': 'CAC-Token',
  // 访问基础路径
  'route': '/',
  // 关于我们地址
  'aboutUs': {
    'zh': '',
    'en': ''
  },
  // 帮助手册地址
  'handBook': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E6%99%8B%E6%B1%9F%E9%9E%8B%EF%BC%88%E4%BD%93%EF%BC%89%E5%8D%9A%E4%BC%9A%E7%BA%BF%E4%B8%8A%E5%B1%95%E5%B1%95%E5%95%86%E5%90%8E%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf',
  'handBook_en': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E6%99%8B%E6%B1%9F%E9%9E%8B%EF%BC%88%E4%BD%93%EF%BC%89%E5%8D%9A%E4%BC%9A%E7%BA%BF%E4%B8%8A%E5%B1%95%E5%B1%95%E5%95%86%E5%90%8E%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf',
  // 客商版中文帮助手册
  'v_handBook_cn': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E6%99%8B%E6%B1%9F%E9%9E%8B%EF%BC%88%E4%BD%93%EF%BC%89%E5%8D%9A%E4%BC%9A%E7%BA%BF%E4%B8%8A%E5%B1%95%E8%A7%82%E4%BC%97%E5%90%8E%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf',
  // 客商版英文帮助手册
  'v_handBook_en': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E6%99%8B%E6%B1%9F%E9%9E%8B%EF%BC%88%E4%BD%93%EF%BC%89%E5%8D%9A%E4%BC%9A%E7%BA%BF%E4%B8%8A%E5%B1%95%E8%A7%82%E4%BC%97%E5%90%8E%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf',
  // 邀请函地址
  'invitation': 'http://yzt.exporegist.com/blOctober/main.html?id=',
  // 首页是否下载app
  'downApp': true,
  // 首页超链接地址
  'link': {
    'facebook': {
      'href': 'https://www.facebook.com/jiang.jin.142',
      'account': ''
    },
    'twitter': {
      'href': 'https://twitter.com/FashionSandals',
      'account': ''
    },
    'instagram': {
      'href': '',
      'account': ''
    },
    'pinterest': {
      'href': '',
      'account': ''
    },
    'linkedin': {
      'href': 'https://www.linkedin.com/in/jinjiangfootwear?trk=nav_responsive_tab_profile_pic',
      'account': ''
    },
    'youtube': {
      'href': 'https://www.youtube.com/c/FootwearJinjiangChina',
      'account': ''
    }
  },
  // 首页banner图
  'indexBanner': [{
    id: 0,
    coverIcon: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/banner0.png',
    urlType:'EXTERNAL',
    url: 'http://i.cn-jif.com/live/4537',
    title: '',
    showType: 'HOME',
    subjectType: '',
    isLogin: true
  },{
    id: 1,
    coverIcon: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/banner.jpg',
    urlType: '',
    title: '',
    showType: 'HOME',
    subjectType: '',
    isLogin: true
  }],
  // 首页视频轮播
  'carouselArr': [
    // {
    //   name: '',
    //   url:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/1.m4v',
    //   urlEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/1.m4v',
    //   picture:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/1.png',
    //   pictureEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/1.png',
    //   externalLink: '',
    //   type: 'ACTOR',
    //   index: 1
    // },
    // {
    //   name: '',
    //   url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/zh.mov',
    //   urlEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/en.mov',
    //   picture: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/zh.png',
    //   pictureEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/zh.png',
    //   externalLink: '',
    //   type: 'ACTOR',
    //   index: 2
    // }
    {
      name: '',
      url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/3.mp4',
      urlEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/3.mp4',
      picture: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/3.png',
      pictureEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/3.png',
      externalLink: '',
      type: 'ACTOR',
      index: 3
    },
    {
      name: 'VR',
      url:'http://www.3dqiye.com//anli/klyf/xbh/21a/',
      urlEn:'http://www.3dqiye.com//anli/klyf/xbh/21a/',
      picture:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/4.png',
      pictureEn:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/homeVideo/4.png',
      type: 'EXTERNAL',
      externalLink: 'http://www.3dqiye.com//anli/klyf/xbh/21a/',
      isImge: true,
      index: 4
    }
  ],
  // 首页视频轮播 下班数据
  'dataShow': [],
  // 首页热门展商展品
  homeHotExibits: [{
    id: 1,
    imageURL: 'http://img.jinhanfair.com/UploadFiles/products/2018/3/20180309135323314581877.jpg',
    exhibitorName: '广州市南沙区大岗景昌瓷庄灯饰厂',
    exhibitorFloor: 'W厅423号展位',
    exhibitorIntro: 'Chinese Classic Style Modern Luxury White Porcelain Table Lamp For Home Decor',
    products: [{
      id: 1,
      x: 100,
      y: 150,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    },{
      id: 2,
      x: 600,
      y: 250,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    },{
      id: 3,
      x: 250,
      y: 280,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    },{
      id: 4,
      x: 700,
      y: 400,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    }]
  },{
    id: 2,
    imageURL: 'http://img.jinhanfair.com/UploadFiles/products/2018/3/20180309135323314581877.jpg',
    exhibitorName: '北京萨拉家居用品贸易有限公司',
    exhibitorFloor: 'E厅155号展位',
    exhibitorIntro: 'I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding,I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding,I like snowboarding, I like snowboarding, I like snowboarding, I like snowboarding',
    products: [{
      id: 1,
      x: 200,
      y: 150,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    },{
      id: 2,
      x: 800,
      y: 250,
      name: '陶瓷釉面珐琅广口圆座花瓶',
      description: '直径15cm 高35cm',
      price: '58',
      imageURL: 'https://ef-base-common-img.oss-cn-beijing.aliyuncs.com/ef-img/IMG_20200608_132509_1592186282881.jpg'
    }]
  }],
  // 3D 展馆图广告展品
  mapRecommendProducts: {
    '7F': ['PLACEHODER'],
    '3F': ['f18340550fd4421fb8904b9f202e3d35', '04d68023d84a42c7956d0b3948a18ae7', '8a761f2650e84808bb78634cf15140e6'],
    'M2': [ '04d68023d84a42c7956d0b3948a18ae7',],
    '2F': [ '04d68023d84a42c7956d0b3948a18ae7',],
    '1F': [ '04d68023d84a42c7956d0b3948a18ae7',],
    'B1F': [ '04d68023d84a42c7956d0b3948a18ae7', '19f7a3f9a6fd4e75a424bc39ad2c62d2','2e0912f5a18511eab36cb8599f24f504', '406b4b2bd7b946e48331aadde5995570']
  },
  // 糖酒会展商调研
  'exhibitorResearch': 'https://www.wjx.cn/m/95169110.aspx',
  // 糖酒会展商调研
  'exhibitorResearch_en': 'https://www.wjx.cn/jq/95185178.aspx',
  // 'exhibitorManual': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E7%AC%AC24%E5%B1%8A%E5%8F%82%E5%B1%95%E5%95%86%E6%89%8B%E5%86%8C.pdf',
  // 'exhibitorManual_en': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/%E7%AC%AC24%E5%B1%8A%E5%8F%82%E5%B1%95%E5%95%86%E6%89%8B%E5%86%8C.pdf',
  'exhibitorManual': '',
  'exhibitorManual_en': '',
  // 表单字段
  form: {
    ...form
  },
  // 路由字段
  router: {
    ...router
  },
  // 开关
  settings: {
    ...settings
  },
  // 广告位
  advertisement: {
    ...advertisement
  },
  // 环信IM
  chatFetchCount: 20, // 环信拉取20条记录
  translate: false, // 是否开发翻译
  // 展馆
  HALL_LIST:[
        {
            name: 'Hall 1',
            cnName: '1号馆',
            id: '1号馆'
        },
        {
            name: 'Hall 2',
            cnName: '2号馆',
            id: '2号馆'
        },
        {
            name: 'Hall 3',
            cnName: '3号馆',
            id: '3号馆'
        },
        {
            name: 'Hall 4',
            cnName: '4号馆',
            id: '4号馆'
        },
        {
            name: 'Hall 5',
            cnName: '5号馆',
            id: '5号馆'
        },
        {
            name: 'Hall 6',
            cnName: '6号馆',
            id: '6号馆'
        },
        // {
        //     name: 'Hall 7',
        //     id: 'Hall 7'
        // },
        {
            name: 'Flowers G2',
            cnName: '二层花艺廊',
            id: '2层连廊'
        },
        {
            name: 'Lobby',
            cnName: '序厅',
            id: 'B1层'
        },
        {
            name: 'Lighting Zone',
            cnName: '灯饰展区',
            id: 'M2层'
        },
        {
            name: 'Flowers G3',
            cnName: '三层花艺廊',
            id: '3层连廊'
        },
        {
            name: 'Outdoor',
            cnName: '户外展区',
            id: '1N'
        }
    ]
}